import React from 'react';
import {
  createDispatchHook,
  createSelectorHook,
  createStoreHook,
  Provider,
  ReactReduxContextValue,
  TypedUseSelectorHook,
} from 'react-redux';
import { AnyAction } from 'redux';
import { AppDispatch, RootState } from './store';

type DispatchFunc = () => AppDispatch;
const ReduxContext = React.createContext({} as ReactReduxContextValue<unknown, AnyAction>);
const useStore = createStoreHook(ReduxContext);
const useDispatch = createDispatchHook(ReduxContext);
const useSelector = createSelectorHook(ReduxContext);

const useAppDispatch: DispatchFunc = useDispatch;
const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

const ReduxProvider = ({ store, children }) => (
  <Provider context={ReduxContext} store={store}>
    {children}
  </Provider>
);

// eslint-disable-next-line react-refresh/only-export-components
export { ReduxProvider, ReduxContext, useStore, useAppDispatch, useAppSelector };
